import { render, staticRenderFns } from "./OrderAdmittanceReception.vue?vue&type=template&id=46096185&scoped=true&"
import script from "./OrderAdmittanceReception.vue?vue&type=script&lang=js&"
export * from "./OrderAdmittanceReception.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46096185",
  null
  
)

export default component.exports
import {QItem,QInput,QBtn,QTooltip,QDialog} from 'quasar'
component.options.components = Object.assign({QItem,QInput,QBtn,QTooltip,QDialog}, component.options.components || {})
